"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "2b275e2",
    "raw": "v2.5.0",
    "semverString": "2.5.0"
};
//# sourceMappingURL=version.js.map